<template>
    <div>
        <div class="am-task-tab" v-if="!showAttachment">
            <v-dialog/>
            <div class="am-border-div">
                <div class="am-task-tab-header am-main-top-box">
                    <div class="am-task-tab-title am-main-top-box-title">Tasks</div>
                        <div class="am-task-tab-icons">
                            <a @click="video()" title="Tasks"><svg-icon icon="video" title="Tasks" class="am-glyphicon-medium am-glyphicon-white"></svg-icon></a>
                            <a @click="add()" title="Add Task"><svg-icon icon="add" title="Add Task" class="am-glyphicon-white am-glyphicon-medium"></svg-icon></a>
                            <a v-if="view === 0" @click="active(row)" title="List Active"><svg-icon icon="unhide" class="am-glyphicon-medium am-glyphicon-white" title="List Active"></svg-icon></a>
                            <a v-else-if="view === 1" @click="hidden(row)" title="List Hidden"><svg-icon icon="hide" class="am-glyphicon-medium am-glyphicon-white" title="List Hidden"></svg-icon></a>
                        </div>
                    </div>
                <div class="am-card-body">
                    <div class="top-space"></div>
                        <div class="table-responsive">
                            <table class="am-task-tab-table">
                                <thead>
                                    <tr>
                                        <th class="text-center">V</th>
                                        <th class="text-center">E</th>
                                        <th class="text-center">H</th>
                                        <th class="text-center">AT</th>
                                        <th @click="sort('statusName')">Status<span><img v-if="sortData.currentSort === 'statusName'" :src="sorterArrow"></span></th>
                                        <th @click="sort('typeName')">Type<span><img v-if="sortData.currentSort === 'typeName'" :src="sorterArrow"></span></th>
                                        <th @click="sort('priorityName')">Priority<span><img v-if="sortData.currentSort === 'priorityName'" :src="sorterArrow"></span></th>
                                        <th @click="sort('desc')">Description<span><img v-if="sortData.currentSort === 'desc'" :src="sorterArrow"></span></th>
                                        <th @click="sort('toUser')">Assigned<span><img v-if="sortData.currentSort === 'toUser'" :src="sorterArrow"></span></th>
                                        <th @click="sort('dueDate')">Due<span><img v-if="sortData.currentSort === 'dueDate'" :src="sorterArrow"></span></th>
                                        <th @click="sort('fromUser')">Creator<span><img v-if="sortData.currentSort === 'fromUser'" :src="sorterArrow"></span></th>
                                        <th @click="sort('tranDate')">Date<span><img v-if="sortData.currentSort === 'tranDate'" :src="sorterArrow"></span></th>
                                        <th @click="sort('closedBy')">Closed By<span><img v-if="sortData.currentSort === 'closedBy'" :src="sorterArrow"></span></th>
                                        <th @click="sort('dateClosed')">Closed<span><img v-if="sortData.currentSort === 'dateClosed'" :src="sorterArrow"></span></th>
                                        <th>Attachments</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                      <td v-if="dataByActiveValue.length === 0" class="center no_records_found" colspan="19">
                                        No Tasks found
                                      </td>
                                    </tr>
                                    <tr v-for="row in taskList" :key="row.key" v-if="row.active === view">
                                        <td class="text-center">
                                            <a title="View" @click="viewTask(row)"><svg-icon class="am-glyphicon-medium am-glyphicon-blue" icon="view" title="View"></svg-icon></a>
                                        </td>
                                        <td class="text-center">
                                          <a title="Edit" @click="edit(row)" v-if="$store.state.auth.permissions.PRoverrideTaskChanges == 1 || ($store.state.auth.permissions.PRoverrideOpenTaskChanges == 1 && row.closedBy === null)"><svg-icon icon="edit" class="am-glyphicon-medium am-glyphicon-blue" title="Edit"></svg-icon></a>
                                          <a title="Edit" v-else><svg-icon class="am-glyphicon-medium am-glyphicon-gray" icon="edit" title="Disabled"></svg-icon></a>
                                        </td>
                                        <td  class="text-center" v-if="view === 0"><a v-bind:id=row.id title="Show" @click="showHideModal(row)"><svg-icon icon="unhide" class="am-glyphicon-medium am-glyphicon-blue" title="Show"></svg-icon></a></td>
                                        <td  class="text-center" v-if="view === 1"><a v-bind:id=row.id title="Hide" @click="showHideModal(row)"><svg-icon class="am-glyphicon-medium am-glyphicon-blue" icon="hide" title="Hide"></svg-icon></a></td>
                                        <td class="text-center"><a title="Add Attachment" @click="toggleAttachment(row)"><svg-icon class="am-glyphicon-medium am-glyphicon-blue" icon="import" title="Add Attachment"></svg-icon></a></td>
                                        <td>{{row.statusName}}</td>
                                        <td>{{row.typeName}}</td>
                                        <td>{{row.priorityName}}</td>
                                        <td  :title="row.fullDescription">
                                            {{row.desc.substr(0,30)}}
                                            <div class="am-task-tooltip" v-if="row.desc.length > 30">
                                                ... <span class="am-task-tooltip-text">{{row.desc}}</span>
                                            </div>
                                        </td>
                                        <td>{{row.toUser}}</td>
                                        <td>{{row.dueDate | moment("MM/DD/YYYY")}}</td>
                                        <td>{{row.fromUser}}</td>
                                        <td>{{row.tranDate | moment("MM/DD/YYYY")}}</td>
                                        <td>{{row.closedBy}}</td>
                                        <td>{{row.dateClosed | moment("MM/DD/YYYY")}}</td>
                                        <td v-if="row.attachmentCount > 0"><span class="glyphicon glyphicon-paperclip" title="Attachments"></span></td>
                                        <td v-else></td>
                                    </tr>
                                </tbody>
                            </table>
                          <div class="am-pagination" v-show="dataByActiveValue.length > pageSize">
                          <pagination :allData="dataByActiveValue" :pageSize="pageSize" :sortData="sortData" @setPageData="setPageData"></pagination>
                          </div>
                        </div>
                    </div>
                <div class="am-task-tab-ribbon-bottom am-main-bottom-box"></div>
            </div>
        </div>
      <attachment v-if="showAttachment" :id="taskId" :header="header" :table-name="tableName" :attachment-type="attachmentType" :customer-id="customerId" @toggleAttachment="hideAttachmentComponent"></attachment>
      <modal name="taskEdit" classes="am-vue-modal" ref="taskEdit" width="400px" :pivotY="0.1" height="auto" :scrollable="true" :clickToClose="false" :adaptive="true" :draggable="false" :reset="true">
          <edit-task :edit-row="editRow" :is-edit="taskEdit" :customer-id="id" @closeEditModal="closeEditModal" @refreshList="refreshList" @extendModal="extendEditModal"></edit-task>
        </modal>
        <modal name="confirmHide" classes="am-vue-modal" :clickToClose="false" :pivotY="0.3" height="200px" width="370px">
          <hide-confirmation :index="hideModalData.id" :active="hideModalData.active" name="task" @toggleAction="toggleHide" @closeAction="closeHideModal"></hide-confirmation>
        </modal>
        <play-video v-show="showVideoModal" :videoCode="videoCode" :videoType="videoType"></play-video>
    </div>

</template>

<script>
import api from './../http'
import addTask from './task.vue'
import editTask from './TaskEdit.vue'
import PlayVideo from './PlayVideo.vue'
import HideConfirmation from './HideConfirmation.vue'
import Attachment from './Attachment'
import sort from '@/mixins/tableSorter'
import pagination from '@/components/pagination/pagination.vue'
export default {

  data: function () {
    return {
      name: 'taskTab',
      editRow: {},
      showVideoModal: false,
      videoCode: '335221387',
      videoType: 'vimeo',
      view: 1,
      taskEdit: true,
      hideModalData: {},
      showAttachment: false,
      pageSize: 15,
      taskList: [],
      taskId: 0,
      header: 'Tasks',
      tableName: 'task',
      attachmentType: 'isTask',
      customerId: this.id,
      rows: []
    }
  },

  components: {
    pagination,
    Attachment,
    'playVideo': PlayVideo,
    'addTask': addTask,
    'editTask': editTask,
    'hideConfirmation': HideConfirmation
  },

  mixins: [sort],

  methods: {
    setPageData (data) {
      this.taskList = data
    },
    edit: function (row) {
      this.editRow = row
      this.taskEdit = true
      this.$modal.show('taskEdit')
    },
    add: function () {
      this.editRow = 0
      this.taskEdit = true
      this.$modal.show('taskEdit')
    },
    viewTask: function (row) {
      this.editRow = row
      this.taskEdit = false
      this.$modal.show('taskEdit')
    },
    show: function () {
      this.hideModalData.active = 1
      return api.makeRequest('/tasks/' + this.hideModalData.id + '/show')
    },
    hide: function () {
      this.hideModalData.active = 0
      return api.makeRequest('/tasks/' + this.hideModalData.id + '/hide')
    },
    showHideModal: function (row) {
      this.hideModalData = row
      this.$modal.show('confirmHide')
    },
    toggleHide () {
      if (this.hideModalData.active) {
        this.hide()
      } else {
        this.show()
      }
      this.closeHideModal()
    },
    closeHideModal: function () {
      this.$modal.hide('confirmHide')
    },
    hidden: function () {
      this.view = 0
    },
    active: function () {
      this.view = 1
    },
    video: function () {
      this.showVideoModal = true
      this.$modal.show('playVideo')
    },
    closeEditModal: function () {
      this.$modal.hide('taskEdit')
      document.body.style.overflow = "";
    },

    refreshList: function () {
      this.$asyncComputed.rows.update()
    },

    extendEditModal: function (data) {
      this.$refs.taskEdit.$refs.modal.style.height = this.$refs.taskEdit.$refs.modal.firstChild.clientHeight + 'px'
      this.$refs.taskEdit.$refs.modal.style.top = (150 - data.top) + 'px'
      document.body.style.overflow = "hidden";
    },

    toggleAttachment: function (row) {
      this.taskId = row.id
      this.showAttachment = true
    },

    hideAttachmentComponent: function () {
      this.showAttachment = false
      this.refreshList()
    }
  },

  props: {
    id: { //  customerId
      type: [Number, String],
      required: true
    }
  },
  computed: {
    dataByActiveValue() {
      let view = this.view
      if (!this.rows){
        return [];
      }
      return this.rows.filter(row => row.active === view)
    }
  },

  asyncComputed: {
    rows: {
      get() {
        let self = this
        return api.makeRequest('/tasks/list/' + self.id).then(
          (data) => {
            if (typeof data.data.tasks === 'undefined'){
              return [];
            }else{
              return data.data.tasks
            }
          }
        )
      },
      default: []
    }
  }
}
</script>

<style scoped>

    .am-border-div{
        border: 1px solid #8c8c8c;
    }

    .am-task-tab-header {
        height: 35px;
    }

    .am-task-tab-header a {
        float: right;
        margin-top: 6px;
        margin-right: 5px;
    }

    .am-task-tab-icons {
        margin-right: 15px;
        cursor: pointer;
    }

    .am-task-tab-title {
        font-size: 14px;
        font-weight: bold;
        float: left;
        margin-left: 25px;
        margin-top: 5px;
    }

    .am-card-body {
        border-top:1px solid #8c8c8c;
        border-bottom:1px solid #8c8c8c;
    }

    .top-space {
        padding: 10px;
    }

    .am-task-tab-table {
        width: 1150px;
        margin-left: 13px;
        margin-bottom: 18px;
    }

    .am-task-tab-table tbody tr:nth-child(odd) {
        background-color: #ECECEC;
    }

    .am-task-tab-table tbody tr:nth-child(even) {
        background-color: #F4F4F4;
    }

    .am-task-tab-table thead {
        background-color: #444444;
        color: white;
    }

    .am-task-tab-table td {
        padding: 2px;
        text-align: left;
        font-size: 11px;
    }

    .am-task-tab-table th {
        padding: 2px;
        font-size: 11px;
        cursor: pointer;
    }

    .am-task-tab-ribbon-bottom {
        height: 35px;
    }

    .task-tooltip span:hover {
        text-decoration: underline;
        cursor: pointer;
    }

    .am-pointer {
      cursor: pointer;
    }

    .am-task-tooltip {
      position: relative;
      display: inline-block;
    }

    .am-task-tooltip .am-task-tooltip-text {
      height: auto;
      width: auto;
      min-width: 400px;
      top:20%;
      left:100%;
      margin-left:30px;
      transform:translate(0, -50%);
      padding:5px;
      color:#000000;
      background-color:#ffffef;
      font-weight:normal;
      font-size:13px;
      border-radius:8px;
      position:absolute;
      z-index:99999999;
      box-sizing:border-box;
      box-shadow:0 1px 8px rgba(0,0,0,0.5);
      visibility:hidden; opacity:0; transition:opacity 0.8s;
    }

    .am-task-tooltip .am-task-tooltip-text::before {
      position: absolute;
      top: 50%;
      right: 100%;
    }

    .am-task-tooltip:hover .am-task-tooltip-text {
      visibility: visible;
      opacity: 1;
    }

    .v--modal-overlay {
      background-color:rgba(0, 0, 0, 0.7);
    }

    .am-pagination {
      text-align: right;
      padding: 10px;
    }

</style>

<style>
  .am-vue-modal {
    background-color: white;
    text-align: left;
    border-radius: 0;
    box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
    padding: 0;
  }
</style>
